<div class="solve-dialog">
  <awc-input
    [cyData]="'solve-dialog-study-name'"
    label="Name"
    placeholder="Name of study..."
    [value]="studyName"
    (valueChange)="setStudyName($event)"></awc-input>
  <awc-form-select
    label="Static Requirements"
    [placeholder]="selectedStaticItems.length ? '' : 'No Static Requirements'"
    [options]="staticRequirements"
    [multi]="true"
    [clearAll]="true"
    [value]="selectedStaticItems"
    (valueChange)="selectionStaticChanged($event)"></awc-form-select>
  <awc-form-select
    label="Dynamic Requirements"
    [placeholder]="selectedDynamicItems.length ? '' : 'No Dynamic Requirements'"
    [options]="dynamicRequirements"
    [multi]="true"
    [clearAll]="true"
    [value]="selectedDynamicItems"
    (valueChange)="selectionDynamicChanged($event)"></awc-form-select>
  <awc-form-select
    label="Drive Cycles"
    [placeholder]="selectedDCItems.length ? '' : 'No Drive Cycles'"
    [options]="dcRequirements"
    [multi]="true"
    [clearAll]="true"
    [value]="selectedDCItems"
    (valueChange)="selectionDCChanged($event)"></awc-form-select>
  <awc-form-select
    label="Solver Version"
    [placeholder]="selectedCliVersion ? '' : (!cliVersions.length ? 'Loading available versions...' : 'Select Solver Version')"
    [disabled]="!cliVersions.length"
    [options]="cliVersions"
    [value]="[selectedCliVersion]"
    (valueChange)="selectedCliVersion = $event?.[0] ?? ''"></awc-form-select>
  <awc-switch
    [awcTooltipText]="'Extra Memory for large studies'"
    *ngIf="[authEnvironment.DEV, authEnvironment.TEST].includes(environment.type)"
    [checked]="extraMemory"
    [label]="'Extra Memory'"
    (changes)="memoryBoost($event)"
  ></awc-switch>
  <awc-button
    [cyData]="'solve-dialog-confirm-button'"
    text="Confirm"
    [type]="type"
    [disabled]="!studyName || (!selectedStaticItems.length && !selectedDynamicItems.length && !selectedDCItems.length && !selectedCliVersion.length)"
    (buttonClicked)="confirm()"></awc-button>
</div>
